import { useEffect, useRef, useState } from 'react';

const fromWire = values => Object.fromEntries(Object.entries(values).map(([id, tip]) => [id, {home:tip.pred_home ?? '',away:tip.pred_away ?? '',type:tip.pred_result_type || ''}]));
const toWire = values => Object.fromEntries(Object.entries(values).map(([id, tip]) => [id, {pred_home:tip.home,pred_away:tip.away,pred_result_type:tip.type || ''}]));

export default function useSimulationDrafts(league, owner = 'guest') {
  const read = () => fromWire(window.SportsHQSimulation?.read(league, owner) || {});
  const [state, setState] = useState(() => ({league,owner,value:read()}));
  const value = state.league === league && state.owner === owner ? state.value : read();
  const latest = useRef(value);
  latest.current = value;
  useEffect(() => {
    const refresh = event => {
      if (!event.detail?.league || event.detail.league === league) setState({league,owner,value:read()});
    };
    setState({league,owner,value:read()});
    window.addEventListener('shq-scenario-change', refresh);
    return () => window.removeEventListener('shq-scenario-change', refresh);
  }, [league, owner]); // Storage is read only when league/account or an explicit edit changes.
  const update = next => {
    const current = latest.current;
    const result = typeof next === 'function' ? next(current) : next;
    latest.current = result;
    window.SportsHQSimulation?.write(league, toWire(result), owner);
    setState({league,owner,value:result});
  };
  return [value, update];
}
